import { Paper, PaperProps, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";
import Iconify from "../Iconify";

const RootStyle = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    position: "relative",
    "& .MuiTypography-section:not(.MuiTypography-gutterBottom)": {
        marginBottom: theme.spacing(-1),
    },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 10,
}));

interface Props extends PaperProps {
    children: ReactNode;
    onClose?: VoidFunction;
    variant?:
        | "caution"
        | "contained"
        | "containedDark"
        | "containedLight"
        | "elevation"
        | "outlined";
}

export default function CardNeutral({ children, onClose, variant = "contained", ...other }: Props) {
    return (
        <RootStyle variant={variant} {...other}>
            {onClose && (
                <CloseButton onClick={onClose}>
                    <Iconify icon="eva:close-fill" />
                </CloseButton>
            )}
            {children}
        </RootStyle>
    );
}
